import { format, isValid } from "date-fns";
import { FileEventType } from "../../../../types/fileEventType";
import { Text } from "../../../Type";
import styles from "./index.module.scss";

const HistoryRow = ({ event }: { event: FileEventType }) => {
  const date = event.created_at ? new Date(event.created_at) : null;
  return (
    <>
      <div className={styles.container}>
        <div>
          <Text>{event.message}</Text>
        </div>
        <div>
          <Text size="small" lineHeight="medium" className={styles.date}>
            {date && isValid(date)
              ? format(date, "MM/dd/yyyy hh:mm:ss")
              : "—"}
          </Text>
        </div>
      </div>
    </>
  );
};

export default HistoryRow;
